import * as React from "react";
import { TimeStampModifiers } from "./../../../../data/helpers/enum"

export class TimeStamp extends React.Component<{
    text: string,
    modifier: TimeStampModifiers
}, {}> {
    render() {
        let cls = "rj-superbanner__event-timestamp";
        let dataUаt = `superbanner-event-timestamp-${this.props.modifier}`
        return (
            <span className={`${cls} ${cls}--${this.props.modifier}`} data-uat={dataUаt}>{this.props.text}</span>
        )
    }
}